import { createSlice } from "@reduxjs/toolkit";

const date = new Date();
const firstDay = new Date(date.getFullYear(), date.getMonth(), 1, 1);
const currentDay = new Date(
  date.getFullYear(),
  date.getMonth(),
  date.getDate(),
  1,
);

const initialRelatorioDocumentosFiscais = {
  page: 1,
  limit: 20,
  date: [firstDay, currentDay],
  issueDateStart: firstDay,
  issueDateEnd: currentDay,
  tipoMovimento: "",
};

const initialState = () => {
  return { ...initialRelatorioDocumentosFiscais };
};

export const relatorioDocumentosFiscaisSlice = createSlice({
  name: "relatoriosDocumentosFiscais",
  initialState,
  reducers: {
    handleChangeDate: (state, { payload }) => {
      state.issueDateStart = payload.issueDateStart;
      state.issueDateEnd = payload.issueDateEnd;
    },
    handleFilter: (state, { payload }) => {
      state.tipoMovimento = payload?.tipoMovimento;

      if (payload.date && Array.isArray(payload.date)) {
        state.date = payload.date;
        state.issueDateStart = payload.date[0];
      }
      if (payload.date && Array.isArray(payload.date)) {
        state.issueDateEnd = payload.date[1] || payload.date[0];
      }
    },
    handleParamsPage: (state, { payload }) => {
      state.page = payload;
    },
    handleParamsLimit: (state, { payload }) => {
      state.limit = payload;
    },
  },
});

export const {
  handleChangeDate,
  handleParamsPage,
  handleParamsLimit,
  handleFilter,
} = relatorioDocumentosFiscaisSlice.actions;

export default relatorioDocumentosFiscaisSlice.reducer;
